module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/restrict-processing-575e09a1d85adfa6e25fed87ab104123.svg";